import debounce from "./debounce"

class viewportHelper {
    init() {
        this.onViewportChange = debounce(this.setViewportSize, 300).bind(this);
        window.addEventListener('resize', this.onViewportChange, {passive : true});
        this.setViewportSize();
    }
    setViewportSize() {
        document.querySelector('html').style.setProperty("--viewport-height", window.innerHeight+"px");
        document.querySelector('html').style.setProperty("--viewport-width", document.body.clientWidth+"px");
    }
}
var vpHelper = new viewportHelper();
export default vpHelper;
